import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-10 px-4 bg-brand-petrol text-white border-t-8 border-brand-gold" data-id="element-51">
      <div className="max-w-3xl mx-auto text-center" data-id="element-52">
        <p className="text-sm font-extrabold text-brand-gold uppercase tracking-widest mb-2" data-id="element-53">
          ONE LAST CHANCE
        </p>

        <p className="text-base sm:text-lg font-medium mb-5 leading-snug max-w-2xl mx-auto" data-id="element-54">
          Your students deserve the best version of you, not an exhausted one.
          Stop spending your Sundays planning. Take back control of your career
          with elite tools.
        </p>

        <div className="bg-white/10 border-2 border-white/20 rounded-xl p-4 mb-5 shadow-lg" data-id="element-55">
          <p className="text-sm sm:text-base font-bold mb-1 uppercase tracking-wide" data-id="element-56">
            Pack 6-in-1: Yoga Ready™ + 5 Luxury Bonuses
          </p>
          <p className="text-lg line-through opacity-70 mb-0.5" data-id="element-57">$97 USD</p>
          <p className="text-4xl font-serif font-extrabold text-brand-gold" data-id="element-58">
            Only: $27 USD
          </p>
        </div>

        <img src="https://cdn.magicpatterns.com/uploads/4bHTedV1cSBKAqW87FCj9F/ChatGPT_Image_14_jun_2026,_12_05_24_a.m..png" alt="Yoga Ready 6-in-1 Box Set" className="w-full max-w-[200px] mx-auto object-contain drop-shadow-2xl mb-5" data-id="element-59" />

        <CTAButton href="https://yoga.impultienda.ar/checkout" className="max-w-md mx-auto !bg-brand-gold !text-brand-graphite border-none shadow-[0_4px_14px_0_rgba(200,168,107,0.39)] hover:shadow-[0_6px_20px_rgba(200,168,107,0.23)] hover:bg-brand-gold/90 mb-4" data-id="element-60">
          🚀 YES, I WANT MY YOGA READY™ PACK
        </CTAButton>

        <div className="flex flex-wrap justify-center items-center gap-x-5 gap-y-2 text-xs sm:text-sm font-bold opacity-90" data-id="element-61">
          <div className="flex items-center gap-1" data-id="element-62">
            <Zap className="w-4 h-4 text-brand-gold" data-id="element-63" />
            <span data-id="element-64">Immediate Access — Delivered by Email</span>
          </div>
          <span className="hidden sm:inline text-brand-gold" data-id="element-65">•</span>
          <div className="flex items-center gap-1" data-id="element-66">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-67" />
            <span data-id="element-68">4.9/5 — Verified Professional Reviews</span>
          </div>
          <span className="hidden sm:inline text-brand-gold" data-id="element-69">•</span>
          <div className="flex items-center gap-1" data-id="element-70">
            <Shield className="w-4 h-4 text-brand-gold" data-id="element-71" />
            <span data-id="element-72">7-Day Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}